







import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
@Component
export default class ImagePopup extends Vue {
    @Prop()
    protected imageUrl!: string;

    constructor() {
        super();
    }

    created() {}

    private close() {
        this.$emit('close');
    }
}
